import Tag from "@eisinc/MobiusOverrides/Tag";

export default Tag;

export * from "@eisinc/MobiusOverrides/Tag";
